import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import {toast} from "react-toastify";
import axios from "../../../services/interceptor/Interceptor";
import Config from "services/config/config";
import { handleValidateObj } from 'constants/objValues/objvalues';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import "./consume.css";
import Images from 'assets/images/imageData';
import { use } from 'react';
const SiteConsumes = ({
  match,
  getSiteConsumablesItems,
  siteConsumables,
  updateSiteConsumesByOps
}) => {
  const installationInput = {
    comm_id: '',
    consumables: 'No',
    consumablesData:[]
  };
  const [installationData, setInstallation] = useState(installationInput);
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const emailModalHide = () => setModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const [consumeData, setConsumeData] = useState(null);
  const [addItem, setAddItem] = useState(1);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [handoverPending, setHandoverPending] = useState(0);
  const [masterConsumables, setMasterConsumables] = useState(null);
    
  useEffect(() => {
    if (getSiteConsumablesItems !== null && match.params.commId && match.params.commId == 0);
    (async () => {
      setIsLoading(true);
      await getSiteConsumablesItems(match.params.commId);
      setIsLoading(false);
    })();
  },[getSiteConsumablesItems,match.params.commId]);
  const handleAddClick = () => {
    setInstallation(prevState => ({
      ...prevState,
      consumablesData: [
        ...prevState.consumablesData,
        {
          name: "",
          name_other: "",
          make: "",
          uom: "",
          sales_qty: "",
          ops_qty: "",
          base_unit_price: "",
          sale_unit_price: "",
          make_items:[],
          new_item: false
        },
      ],
    }));
  };
  const handleRemoveClick = (index) => {
    setInstallation(prevState => ({
      ...prevState,
      consumablesData: prevState.consumablesData.filter((_, i) => i !== index)
    }));
  };
  const handleInput2Value = (val, key, index) => {
    if(key && key === 'name') {
      var parts = val.split(" - ");
      var category = parts[0];
      var description = parts.length > 1 ? parts[1] : "";
      var currentItem = masterConsumables.find(item => 
        item.category_name.trim().toLowerCase() === category.trim().toLowerCase() &&
        item.description.trim().toLowerCase() === description.trim().toLowerCase()
      );
      var basePrice = currentItem?.base_price;
      var makeItems = currentItem?.make_items;
      var uomItem = currentItem?.uom;
    }
    setInstallation(prevState => ({
      ...prevState,
      consumablesData: prevState.consumablesData.map((item, i) => 
        i === index 
          ? { 
              ...item, 
              [key]: val, 
              ...(key === 'name' && {make: "", name_other: "", uom: "", sales_qty: "", ops_qty: "", base_unit_price: "", sale_unit_price: "", make_items: [], new_item: true }
              ),
              ...(key === 'sales_qty' && { ops_qty: val }),
              ...(key === 'name' && basePrice && { base_unit_price: basePrice, sale_unit_price: basePrice, make_items: makeItems, uom: uomItem})
            } 
          : item
      )
    }));
  };
  useEffect(() => {
    if(siteConsumables !== undefined && siteConsumables !== null) {
      const {
        comm_id,
        consumable_required,
        consumable_items,
        handover_done
      } = siteConsumables;
      setTimeout(() => {
        setInstallation({
          ...installationData,
          comm_id: comm_id,
          consumables: consumable_required,
          consumablesData: consumable_items ?? [{
            name: "",
            name_other: "",
            make: "",
            uom: "",
            sales_qty: "",
            ops_qty: "",
            base_unit_price: "",
            sale_unit_price: "",
            make_items:[]
          }]
        });
      }, 100);
      setConsumeData(siteConsumables);
      setHandoverPending(siteConsumables?.action_freeze);
      setMasterConsumables(siteConsumables?.master_consumables_items);
    }
  },[siteConsumables]);
  
//  console.log('check>> ' + handoverPending);
  const handleConsumeData = async () => {
    if(installationData?.consumables && installationData?.consumables === 'Yes') {
      // console.log('dd ' + JSON.stringify(installationData?.consumablesData));
      var allChecks = false;
      installationData?.consumablesData.forEach(element => {
        if(element.name == '') {
            toast.error('Consumable name is required');
            allChecks = true;
            return false;
        }
        if(element?.scope == '') {
          toast.error('Consumable scope is required');
          allChecks = true;
          return false;
        }  
        if(element.name !== '') {
            if(element.make == '') {
              toast.error('Make is required');
              allChecks = true;
              return false;
            }
            if(element.uom == '') {
              toast.error('UOM is required');
              allChecks = true;
              return false;
            }
            if(element.name === 'Others') {
              if(element.name_other == '' || element.name_other == null) {
                toast.error('Others field is required');
                allChecks = true;
                return false;
              }
            }
            // if(element.sales_qty == '') {
            //   toast.error('Sales Quantity is required');
            //   allChecks = true;
            //   return false;
            // }
            if(element.ops_qty == '' || element.ops_qty == 0) {
              toast.error('Ops Quantity is required');
              allChecks = true;
              return false;
            }
            // if(element.base_unit_price == '') {
            //   toast.error('Unit price is required');
            //   allChecks = true;
            //   return false;
            // }
            if(element.sale_unit_price == '') {
              toast.error('Sale Unit price is required');
              allChecks = true;
              return false;
            }
        }
      });
      if(allChecks) {
        return false;
      }
    }
    setIsLoading(true);
    const res = await updateSiteConsumesByOps(installationData);
    console.log(res);
    if(res == true) {
        setIsLoading(false);
        setIsSuccessModel(true);
    } else {
      setIsLoading(false);
      toast.error('Error in updating site consumes');
    }
    console.log('00 -> ' + JSON.stringify(installationData));
  }
  const handleRejectModalHide = () => {
    setIsSuccessModel(false);
    window.location.reload();
  }
  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <button onClick={handleRejectModalHide} className='btn btn-primary btn-sm text-center'>Close</button>
      </div>
    );
  };
  return (
    <Layout
      title={localization.consumableItems}
      isGoback
      linkFlag={true}
      linkUrl={`/dashboard/site-listing`}
      isLoading={isLoading}
    >
      <>
      <FormSection title={localization.consumableItems}>
          <div className='col-md-6'>
            <DropDownInput 
                label={localization.consumables}
                data={[
                  { id: 'Yes', name: 'Yes' },
                  { id: 'No', name: 'No' },
                ]}
                required
                errorMsg={localization.requiredScope}
                getIdValue={(val) =>{
                  setInstallation({
                    ...installationData,
                    consumables: val.id,
                  });
                }
                }
                value={installationData?.consumables != '' ? installationData?.consumables : 'No'}
                isStarRequired={true}
                // disabled={!handoverPending ? false : true}
                disabled={true}
            />
          </div>
      {installationData?.consumables === 'Yes' && 
        <div>
        {addItem === 1 ? (
          <>
          {installationData?.consumablesData?.length > 0 && installationData?.consumablesData.map((x, i) => {
             return (
                  <div className="main-div__layout" key={'k_' + i}>
                    <div className="container row">
                    <div className="col-md-9 col-sm-12">
                        {/* <ConstantInput
                          label={localization.name}
                          type="text"
                          required={true}
                          isStarRequired={true}
                          errorMsg={localization.isRequired}
                          handleChange={(val) => {
                            handleInput2Value(val, "name", i);
                          }}
                          value={x?.name}
                          disabled={!handoverPending ? false : true}
                        /> */}
                        {console.log(i + ' - ' + x?.new_item)}
                        <DropDownInput
                          label={localization.name}
                          data={masterConsumables[i]?.all_combinations}
                          required
                          errorMsg={localization.requiredScope}
                          getIdValue={(val) => {
                            handleInput2Value(val.id, "name", i);
                          }}
                          value={x?.name ?? ''}
                          isStarRequired={true}
                          // disabled={!handoverPending ? false : true}
                          disabled={(x?.new_item == undefined) ? true : false}
                        />
                      </div>
                      {x?.name && x?.name === 'Others' && 
                      <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.others}
                          type="text"
                          required={true}
                          isStarRequired={true}
                          errorMsg={localization.isRequired}
                          handleChange={(val) => {
                            handleInput2Value(val, "name_other", i);
                          }}
                          value={x?.name_other}
                          disabled={(x?.new_item == undefined) ? true : false}
                        />
                      </div>
                      }
                      <div className="col-md-3 col-sm-12">
                        <DropDownInput
                          label={localization.make}
                          data={x?.make_items}
                          required
                          errorMsg={localization.requiredScope}
                          getIdValue={(val) => {
                            handleInput2Value(val.id, "make", i);
                          }}
                          value={x?.make ?? ''}
                          isStarRequired={true}
                          // disabled={!handoverPending ? false : true}
                          disabled={(x?.new_item == undefined) ? true : false}
                        />
                      </div>
                      {parseInt(x?.scope) !== 1 &&
                       <>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.uom}
                          data={x?.uom}
                          required
                          errorMsg={`UOM is required!`}
                          handleChange={(val) => {
                            handleInput2Value(val, "uom", i);
                          }}
                          value={x?.uom ?? ''}
                          isStarRequired={true}
                          disabled={true}
                        />
                        </div>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.reqSales}
                          className=""
                          type="number"
                          // required
                          // isStarRequired={true}
                          handleChange={(val) => {
                            handleInput2Value(val, "sales_qty", i);
                          }}
                          value={x?.sales_qty}
                          disabled={true}
                        />
                        </div>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.reqOps}
                          className=""
                          type="number"
                          required
                          isStarRequired={true}
                          handleChange={(val) => {
                            handleInput2Value(val, "ops_qty", i);
                          }}
                          value={x?.ops_qty}
                          disabled={!handoverPending ? false : true}
                        />
                        </div>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={localization.baseUnitPrice}
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          type="number"
                          required
                          isStarRequired={true}
                          handleChange={(val) => {
                            handleInput2Value(val, "base_unit_price", i);
                          }}
                          value={x?.base_unit_price}
                          disabled={true}
                        />
                        </div>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={`Sale Unit Price`}
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          type="number"
                          // required
                          // isStarRequired={true}
                          handleChange={(val) => {
                            handleInput2Value(val, "sale_unit_price", i);
                          }}
                          value={x?.sale_unit_price}
                          disabled={true}
                        />
                        </div>
                        <div className="col-md-3 col-sm-12">
                        <ConstantInput
                          label={`Total Price`}
                          className="indianrupee"
                          isPrefix
                          prefixText={'₹'}
                          type="number"
                          required
                          isStarRequired={true}
                          // handleChange={(val) => {
                          //   handleInput2Value(val, "sale_unit_price", i);
                          // }}
                          value={parseFloat(x?.sale_unit_price * x?.ops_qty)}
                          disabled={true}
                        />
                        </div>
                        </>
                      }
                      <div className="col-md-3 col-sm-12 d-flex">
                        {!handoverPending && installationData?.consumablesData.length !== 1 && (
                          <div className="col-md-2 col-sm-5">
                            <button
                              onClick={() => handleRemoveClick(i)}
                              className="mr10 btn btn-sm btn-danger"
                            >
                              Remove
                            </button>
                          </div>
                        )}
                        {!handoverPending && installationData?.consumablesData.length - 1 === i && (
                          <div className="col-md-2 col-sm-5">
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={handleAddClick}
                            >
                              Add
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <span class="section-divider"></span>
                  </div>
                );
              })}
            </>
            ) : addItem === 2 ? (
              {}
            ) : null}
          </div>
          }
          {!handoverPending &&
            <div className="form-group col-10">
              <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => handleConsumeData()}
              >
              {'Submit'} <img src="" alt="" />
              </button>
            </div>
          } 
          </FormSection>
          <ModalPop
            title={localization.success}
            show={isSuccessModel}
            handleModalHide={handleRejectModalHide}
          >
            {successIconBox(localization.itemUpdateSuccess, handleRejectModalHide)}
          </ModalPop>
          </>
    </Layout>
  );
};
export default SiteConsumes;